import { customerApi, setTokens, USE_XSRF_HEADER } from '@/api'
import {
  ILineFriendsResponse,
  ILineInviteRequest,
  ILineInviteResponse,
  IMgmInquireResponse,
} from '@/domains/InviteDomain'
import { IFinGetLineInfo } from '@/utils/bridgeUtils/features/finGetLineInfo'

// 라인 친구리스트 받아오기
const PROMO = '/promo/referral'
export const fetchLineFriends = (data: IFinGetLineInfo | null): Promise<ILineFriendsResponse> => {
  const accessToken = data?.accessToken || ''
  const userId = data?.lineUserId || ''

  setTokens(accessToken, userId)

  return customerApi.post(`${PROMO}/line-friends`, null, USE_XSRF_HEADER)
}

// 라인 친구 초대하기
export const fetchInviteFriends = (data: ILineInviteRequest): Promise<ILineInviteResponse> => {
  return customerApi.post(`${PROMO}/invite-friends`, data, USE_XSRF_HEADER)
}

// MGM Referral Promotion
const MGM = '/promo/mgm'

// referral code 받아오기
export const fetchMGMCode = (): Promise<IMgmInquireResponse> => {
  return customerApi.post(`${MGM}/inquiry`)
}
